import Vue from 'vue';
import { UncaughtError } from '@/utils/errorutils/error';

Vue.config.errorHandler = (err) => new UncaughtError(err);
